import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import TextAreaInputField from "../../../components/forms/TextAreaInputField";
import FormError from "../../../components/forms/FormError";

class ProductBundleForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="SKU"
              name="sku"
              serverError={this.props.errors.sku}
              component={TextInputField}
              />          
            <Field 
              label="Title"
              name="title"
              serverError={this.props.errors.title}
              component={TextInputField}
              />
            <Field 
              label="Description"
              name="description"
              serverError={this.props.errors.title}
              component={TextAreaInputField}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "ProductBundleForm"
})(ProductBundleForm);

export default ReduxForm;